import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const BusinessDetailsForm = ({ formData, onChange, errors }) => {
  const businessTypes = [
    { value: 'limited_company', label: 'Limited Company' },
    { value: 'sole_trader', label: 'Sole Trader' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'llp', label: 'Limited Liability Partnership' }
  ];

  const experienceLevels = [
    { value: '0-2', label: '0-2 years' },
    { value: '3-5', label: '3-5 years' },
    { value: '6-10', label: '6-10 years' },
    { value: '11-15', label: '11-15 years' },
    { value: '16+', label: '16+ years' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Account Security</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Create a secure password to access your agent account after approval.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Password"
            type="password"
            name="password"
            value={formData?.password}
            onChange={onChange}
            error={errors?.password}
            placeholder="Enter password"
            description="Minimum 8 characters"
            required
          />
          
          <Input
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={formData?.confirmPassword}
            onChange={onChange}
            error={errors?.confirmPassword}
            placeholder="Re-enter password"
            required
          />
        </div>
      </div>
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Business Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Company Name"
            type="text"
            name="companyName"
            value={formData?.companyName}
            onChange={onChange}
            error={errors?.companyName}
            placeholder="Enter your company name"
            required
          />
          
          <Input
            label="Company Registration Number"
            type="text"
            name="registrationNumber"
            value={formData?.registrationNumber}
            onChange={onChange}
            error={errors?.registrationNumber}
            placeholder="e.g., 12345678"
            description="UK Companies House number"
          />
          
          <Select
            label="Business Type"
            options={businessTypes}
            value={formData?.businessType}
            onChange={(value) => onChange({ target: { name: 'businessType', value } })}
            error={errors?.businessType}
            placeholder="Select business type"
            required
          />
          
          <Input
            label="VAT Number (Optional)"
            type="text"
            name="vatNumber"
            value={formData?.vatNumber}
            onChange={onChange}
            error={errors?.vatNumber}
            placeholder="GB123456789"
          />
        </div>
      </div>
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Contact Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Business Phone"
            type="tel"
            name="businessPhone"
            value={formData?.businessPhone}
            onChange={onChange}
            error={errors?.businessPhone}
            placeholder="+44 20 1234 5678"
            required
          />
          
          <Input
            label="Business Email"
            type="email"
            name="businessEmail"
            value={formData?.businessEmail}
            onChange={onChange}
            error={errors?.businessEmail}
            placeholder="info@yourcompany.com"
            description="This email will be your login username"
            required
          />
          
          <div className="md:col-span-2">
            <Input
              label="Business Address"
              type="text"
              name="businessAddress"
              value={formData?.businessAddress}
              onChange={onChange}
              error={errors?.businessAddress}
              placeholder="Enter your business address"
              required
            />
          </div>
          
          <Input
            label="City"
            type="text"
            name="city"
            value={formData?.city}
            onChange={onChange}
            error={errors?.city}
            placeholder="London"
            required
          />
          
          <Input
            label="Postcode"
            type="text"
            name="postcode"
            value={formData?.postcode}
            onChange={onChange}
            error={errors?.postcode}
            placeholder="SW1A 1AA"
            required
          />
        </div>
      </div>
      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Professional Information</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Full Name"
            type="text"
            name="fullName"
            value={formData?.fullName}
            onChange={onChange}
            error={errors?.fullName}
            placeholder="Enter your full name"
            required
          />
          
          <Input
            label="Professional Title"
            type="text"
            name="professionalTitle"
            value={formData?.professionalTitle}
            onChange={onChange}
            error={errors?.professionalTitle}
            placeholder="e.g., Travel Consultant, Director"
            required
          />
          
          <Select
            label="Years of Experience"
            options={experienceLevels}
            value={formData?.experience}
            onChange={(value) => onChange({ target: { name: 'experience', value } })}
            error={errors?.experience}
            placeholder="Select experience level"
            required
          />
          
          <Input
            label="Professional Qualifications"
            type="text"
            name="qualifications"
            value={formData?.qualifications}
            onChange={onChange}
            error={errors?.qualifications}
            placeholder="e.g., ABTA, ATOL, CIM"
            description="Travel industry certifications"
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessDetailsForm;